import React from "react";
import { RouteComponentProps } from "react-router";
import { queriesCustomFields, queriesPayables } from "@query";
import { WSQueries } from "../../../query/WSQuery";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { PayableForm } from "../../components/PayableForm/PayableForm";
import { PAYABLE_EXPAND } from "../../constants";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";

export const EditPayable: React.FC<
  RouteComponentProps<
    {
      payableId: string;
    },
    any,
    {
      backPath?: string;
    }
  >
> = ({ match, location }) => {
  const payableId = match.params.payableId;
  const xWingspanAccount = useXWingspanPayerId();
  const payableQuery = queriesPayables.getPayable.useQuery({
    payableId,
    xWingspanAccount,
    expand: PAYABLE_EXPAND
  });
  const queryCustomFields = queriesCustomFields.listCustomFields.useQueryAll({
    filter: { resourceType: { eq: CustomFieldResourceType.LINE_ITEM } }
  });
  const customFields = queryCustomFields.flatData;

  const backPath = location.state?.backPath;

  return (
    <WSQueries queries={{ payableQuery, queryCustomFields }}>
      {({ payableQuery: { data: payable } }) => (
        <PayableForm
          backPath={backPath}
          payable={payable}
          customFields={customFields}
        />
      )}
    </WSQueries>
  );
};
